import { LoaderActions } from '@store/loaders'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import { closeModal } from '@storeOld/reducers/ui'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { InternalTemplatesActions, type TemplatesActions } from '../actions'
import type { TemplateCopy } from '../types'
import { TemplateSavedNotification } from './notifications'

export const SAVE_TEMPLATE_ERROR =
  'Something has gone wrong. Please try again later.'

export function* saveTemplate({
  payload: { projectId, name, workspaceId },
}: ReturnType<typeof TemplatesActions.save>) {
  yield put(InternalTemplatesActions.saveReset())
  yield put(LoaderActions.set('template_save'))

  try {
    // The personal workspace sends no teamId: the template stays with the
    // user. A team workspace passes its uuid and the template joins the team.
    const payload =
      workspaceId === PERSONAL_WORKSPACE_ID
        ? { name }
        : { name, teamId: workspaceId }

    const template: TemplateCopy = yield call(
      API.Template.saveAsTemplate,
      projectId,
      payload
    )

    sendGtmEvent(GtmTriggerName.TEMPLATE_SAVE, 'Save as template')

    // The modal is the "Save as template" one: the save is the only thing it
    // does, so success closes it and the toast carries the way to the copy.
    yield put(closeModal())
    yield put(TemplateSavedNotification(template.id))
  } catch (error) {
    console.error('Failed to save template', error)

    // Shown inside the modal, which stays open for another try.
    yield put(InternalTemplatesActions.saveFailed(SAVE_TEMPLATE_ERROR))
  } finally {
    yield put(LoaderActions.unset('template_save'))
  }
}
